import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { Badge as Badge$1, HStack, Box } from '@chakra-ui/react';
import { Text } from '@outdoorly/text';

var _excluded = ["variant", "colorScheme", "label", "leftIcon", "rightIcon", "size"];
var Badge = function Badge(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
    _ref$colorScheme = _ref.colorScheme,
    colorScheme = _ref$colorScheme === void 0 ? 'gray' : _ref$colorScheme,
    label = _ref.label,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Badge$1, _extends({}, props, {
    variant: variant,
    colorScheme: colorScheme,
    borderRadius: "md"
  }), /*#__PURE__*/React.createElement(HStack, {
    spacing: 1,
    p: 1
  }, leftIcon, /*#__PURE__*/React.createElement(Text, {
    maxW: "full",
    size: size,
    color: "currentColor",
    fontWeight: "500",
    as: "div"
  }, /*#__PURE__*/React.createElement(Box, {
    as: "p",
    isTruncated: true
  }, label)), rightIcon));
};

export { Badge };
